import { render, staticRenderFns } from "./ruleEditor.vue?vue&type=template&id=487b69c0&"
import script from "./ruleEditor.vue?vue&type=script&lang=js&"
export * from "./ruleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports